import { render } from "./Vendor.vue?vue&type=template&id=c64b45da&scoped=true"
import script from "./Vendor.vue?vue&type=script&lang=js"
export * from "./Vendor.vue?vue&type=script&lang=js"

import "./Vendor.vue?vue&type=style&index=0&id=c64b45da&scoped=true&lang=css"
import "./Vendor.vue?vue&type=style&index=1&id=c64b45da&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64b45da"]])

export default __exports__